module.exports = __webpack_public_path__ + "img/40012.fc46e857.png";